import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import removeQueryParam from '../../utils/removeQueryParam';
import { PaginationProps } from './Pagination.types';

import styles from './Pagination.module.css';

const Pagination = ({ currentPage, total, className }: PaginationProps) => {
  const router = useRouter();
  const [pagesList, setPagesList] = useState<(number | string)[]>([]);
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    getVisiblePages();
  }, [currentPage, router]);

  const getVisiblePages = () => {
    if (currentPage % 5 >= 0 && currentPage > 4 && currentPage + 2 < total) {
      setPagesList([
        1,
        '...',
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2,
        '...',
        total,
      ]);
    } else if (currentPage < 6 && total < 6) {
      let start = 1;
      const arr = [];
      while (start <= total) {
        arr.push(start++);
      }
      setPagesList([...arr]);
    } else if (currentPage % 5 >= 0 && currentPage > 4 && currentPage + 2 >= total) {
      setPagesList([1, '...', total - 3, total - 2, total - 1, total]);
    } else {
      setPagesList([1, 2, 3, 4, 5, '...', total]);
    }
  };

  // Для первого рендера, чтобы корректно отрендерить (нужно для SEO)
  if (firstRender) {
    setFirstRender(false);
    getVisiblePages();
  }

  return (
    <div className={`${styles.pagination} ${className}`}>
      {pagesList.length > 0 &&
        pagesList.map((i, index) => {
          {
            if (i === '...')
              return (
                <span
                  className={`${styles.pagination__item} ${styles.pagination__dots}`}
                  key={`${i}_${index}`}
                >
                  {i}
                </span>
              );
            else if (i === currentPage)
              return (
                <span
                  className={`${styles.pagination__item} ${styles.pagination__current}`}
                  key={`${i}_${index}`}
                >
                  {i}
                </span>
              );
            else if (i === 1)
              return (
                <Link
                  href={{
                    query: { ...removeQueryParam(router, 'page') },
                  }}
                  key={`${i}_${index}`}
                >
                  <a className={styles.pagination__item}>{i}</a>
                </Link>
              );
            else if (i !== currentPage)
              return (
                <Link
                  href={{
                    query: { ...router.query, page: i },
                  }}
                  key={`${i}_${index}`}
                >
                  <a className={styles.pagination__item}>{i}</a>
                </Link>
              );
          }
        })}
    </div>
  );
};

export default Pagination;
